import { ApiRequestFilters } from '../../../shared/types/api-request-filters';

/**
 * File log filters
 */
export class FileLogFilters extends ApiRequestFilters {
	/**
	 * User IDs
	 */
	users?: number[];
}
